import SceneObject from "../../../lib/services/scene/sceneobject";
import ShaderService from "../../../lib/services/shader/shader_service";
import ResourceService from "../../../lib/services/resource/resourceservice";
import Camera from "../../../lib/services/scene/camera";
import ScrimRenderPipeline from "./scrim_renderpipeline";

export default class Scrim extends SceneObject {
  private pipeline: ScrimRenderPipeline;
  private active: boolean = false;
  private alpha: number = 0;
  private target_alpha: number = 0;

  // Fade timing
  private static FADE_RATE = 6.0; // alpha units per second

  // Visual tuning
  private static SCRIM_COLOR: [number, number, number, number] =
    [0.05, 0.04, 0.03, 0.75]; // warm-tinted near-black at 75% peak

  constructor(key: string) {
    super(key);
    this.pipeline = new ScrimRenderPipeline("scrim", "scrim");
    this.layer = 1; // above scene, below video
  }

  async build(
      device: GPUDevice,
      format: GPUTextureFormat,
      shader_service: ShaderService,
      resource_service: ResourceService): Promise<void> {
    await this.pipeline.build(device, format, shader_service, resource_service);
  }

  override ui_message(cmd: string, msg: string): void {
    super.ui_message(cmd, msg);
    if (cmd === "scan_sticker") {
      this.active = !this.active;
      this.target_alpha = this.active ? Scrim.SCRIM_COLOR[3] : 0;
    }
  }

  override tick(delta_time: number): void {
    // Smoothly approach target alpha
    const step = Scrim.FADE_RATE * delta_time;
    if (this.alpha < this.target_alpha) {
      this.alpha = Math.min(this.target_alpha, this.alpha + step);
    } else if (this.alpha > this.target_alpha) {
      this.alpha = Math.max(this.target_alpha, this.alpha - step);
    }
  }

  override prepare(device: GPUDevice, camera: Camera): void {
    if (this.alpha <= 0.001) return;

    this.pipeline.update_color(
      device,
      Scrim.SCRIM_COLOR[0],
      Scrim.SCRIM_COLOR[1],
      Scrim.SCRIM_COLOR[2],
      this.alpha
    );
    this.pipeline.prepare(device);
  }

  override draw(pass: GPURenderPassEncoder): void {
    if (this.alpha <= 0.001) return;
    this.pipeline.draw(pass);
  }
}